import React from "react";
import "../../Styles/yellowcalf.css/Wallet_Sales_Report.css";

function Wallet_Sales_Report() {
  return (
    <div className="wallet-report-container" style={{ paddingTop: "25px" }}>
      <div className="wallet-header-section">
        <div className="wallet-header-box">
          <h3 className="wallet-header-title">Wallet Sales Report</h3>

          <div className="wallet-export-section">
            <button className="wallet-export-button">
              Export <i className="fa fa-angle-down"></i>
            </button>

            <ul className="wallet-export-list">
              <li>
                <a href="#">Save as PDF</a>
              </li>
              <li>
                <a href="#">Save as PNG</a>
              </li>
              <li>
                <a href="#">Save as CSV</a>
              </li>
              <li>
                <a href="#">Save as TXT</a>
              </li>
              <li>
                <a href="#">Save as XML</a>
              </li>
              <li>
                <a href="#">Save as SQL</a>
              </li>
              <li>
                <a href="#">Save as JSON</a>
              </li>
              <li>
                <a href="#">Export to Excel</a>
              </li>
              <li>
                <a href="#">Export to Word</a>
              </li>
              <li>
                <a href="#">Export to PowerPoint</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="wallet-filter-section">
        <div className="wallet-filter-row">
          <div className="wallet-filter-item">
            <select id="student_id" className="wallet-select">
              <option value="">Select Student</option>
              <option value="189">ssds - hjh45</option>
              <option value="207">hebu - 78787878</option>
              <option value="211">siva - 34567889</option>
              <option value="186">Kaleem - 456</option>
              <option value="222">testing - 34567889</option>
              <option value="101">Mahesh - 546452367</option>
              <option value="224">ritu - 607046</option>
            </select>
          </div>

          <div className="wallet-filter-item">
            <input
              type="date"
              id="startdate"
              className="wallet-date-input"
              placeholder="Start Date"
            />
          </div>

          <div className="wallet-filter-item">
            <input
              type="date"
              id="enddate"
              className="wallet-date-input"
              placeholder="End Date"
            />
          </div>
          
          <div className="wallet-filter-item">
            <button type="submit" className="wallet-btn wallet-btn-search">
              Search
            </button>
            <button type="reset" className="wallet-btn wallet-btn-clear">
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Wallet_Sales_Report;
